import { render, staticRenderFns } from "./projectIndex.vue?vue&type=template&id=8faeab60&scoped=true"
import script from "./projectIndex.vue?vue&type=script&lang=js"
export * from "./projectIndex.vue?vue&type=script&lang=js"
import style0 from "./projectIndex.vue?vue&type=style&index=0&id=8faeab60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8faeab60",
  null
  
)

export default component.exports